export const MARKETS_NO = {
    match_odds_ft: "Kampodds (full tid)",
    match_odds_ht: "Kampodds (halvtid)",
    goals_ft: "Over/Under {{line}} mål (full tid)",
    goals_ht: "Over/Under {{line}} mål (halvtid)",
    player_scores: "{{player}} scorer (full tid)",
    corners_ft: "Hjørnespark over/under {{line}} (full tid)",
    cards_ft: "Kort over/under {{line}} (full tid)",
    draw: "Uavgjort",
    over: "Over {{line}}",
    under: "Under {{line}}",
    yes: "Ja",
    no: "Nei",
}
